import {Observable} from 'rxjs';
import * as myGlobals from './../global';
import {User} from './user.model';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClientSecured} from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  formData: User = {
    id: 0,
    email: '',
    lastname1: '',
    lastname2: '',
    name: '',
    password: '',
    confirmPassword: '',
    roleId: '',
    status: ''
  };
  list: Observable<User[]>;

  private _userUrl = myGlobals.baseApi + '/webadmin/v1/users';
  // private _addUserUrl = myGlobals.server + '/webadmin/v1/user';
  // private _editUserUrl = myGlobals.server + '/webadmin/v1/user/';
  // private _getUserUrl = myGlobals.server + '/webadmin/v1/user/';

  constructor(private http: HttpClientSecured) {
  }

  allUsers(): Observable<User[]> {
    console.log('UserService: allUsers: Incoming method...');
    return this.http.get<any>(this._userUrl);
  }

  getUsers() {
    return this.http.get<any>(this._userUrl);
  }

  getUser(id: number): Observable<User | undefined> {
    return this.getUsers().pipe(map((users: User[]) => users.find(p => p.id === id)));
  }
}
